import { render, staticRenderFns } from "./staffLogin.vue?vue&type=template&id=2f0ca6bf&scoped=true"
import script from "./staffLogin.vue?vue&type=script&lang=js"
export * from "./staffLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0ca6bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0ca6bf')) {
      api.createRecord('2f0ca6bf', component.options)
    } else {
      api.reload('2f0ca6bf', component.options)
    }
    module.hot.accept("./staffLogin.vue?vue&type=template&id=2f0ca6bf&scoped=true", function () {
      api.rerender('2f0ca6bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/staffList/staffLogin.vue"
export default component.exports